import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecdp',
  templateUrl: './ecdp.component.html',
  styleUrls: ['./ecdp.component.scss'],
})
export class ECDP implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
